<svg
	xmlns:dc="http://purl.org/dc/elements/1.1/"
	xmlns:cc="http://creativecommons.org/ns#"
	xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
	xmlns:svg="http://www.w3.org/2000/svg"
	xmlns="http://www.w3.org/2000/svg"
	xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
	xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
	width="30px"
	viewBox="0 0 24 24"
	fill="none"
	transform="matrix(1, 0, 0, -1, 0, 0)rotate(0)"
	version="1.1"
	id="svg13"
	sodipodi:docname="move-up-svgrepo-com_change.svg"
	inkscape:version="1.0.2-2 (e86c870879, 2021-01-15)"
>
	<metadata id="metadata19">
		<rdf:RDF>
			<cc:Work rdf:about="">
				<dc:format>image/svg+xml</dc:format>
				<dc:type rdf:resource="http://purl.org/dc/dcmitype/StillImage" />
				<dc:title />
			</cc:Work>
		</rdf:RDF>
	</metadata>
	<defs id="defs17" />
	<sodipodi:namedview
		pagecolor="#currentColor"
		bordercolor="currentColor"
		borderopacity="1"
		objecttolerance="10"
		gridtolerance="10"
		guidetolerance="10"
		inkscape:pageopacity="0"
		inkscape:pageshadow="2"
		inkscape:window-width="1044"
		inkscape:window-height="811"
		id="namedview15"
		showgrid="false"
		inkscape:snap-bbox="true"
		inkscape:zoom="1.0625"
		inkscape:cx="400"
		inkscape:cy="325.96078"
		inkscape:window-x="0"
		inkscape:window-y="0"
		inkscape:window-maximized="0"
		inkscape:current-layer="svg13"
	/>
	<g id="SVGRepo_bgCarrier" stroke-width="0" />
	<g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" />
	<g id="SVGRepo_iconCarrier">
		<rect
			x="14"
			y="4"
			width="6"
			height="6"
			stroke="currentColor"
			stroke-width="1"
			stroke-linecap="round"
			stroke-linejoin="round"
			id="rect4"
			style="fill-opacity:0;fill:currentColor"
		/>
		<rect
			x="14"
			y="14"
			width="6"
			height="6"
			stroke="currentColor"
			stroke-width="1"
			stroke-linecap="round"
			stroke-linejoin="round"
			id="rect6"
		/>
		<path
			d="M10 19.3733C8.4087 19.3733 6.88258 18.7411 5.75736 17.6159C4.63214 16.4907 4 14.9646 4 13.3733C4 11.782 4.63214 10.2559 5.75736 9.13065C6.88258 8.00543 8.4087 7.37329 10 7.37329"
			stroke="currentColor"
			stroke-width="1"
			stroke-linecap="round"
			stroke-linejoin="round"
			id="path8"
		/>
		<path
			d="M8.396 5.54468L10.9256 6.98482L9.48551 9.51447"
			stroke="currentColor"
			stroke-width="1"
			stroke-linecap="round"
			stroke-linejoin="round"
			id="path10"
		/>
	</g>
	<rect
		x="16.736469"
		y="7.0235295"
		width="2.9505873"
		height="2.8094115"
		stroke="currentColor"
		stroke-width="1"
		stroke-linecap="round"
		stroke-linejoin="round"
		id="rect4-1"
		style="fill:currentColor;fill-opacity:0"
	/>
	<rect
		x="14.251763"
		y="4.2282352"
		width="2.4847059"
		height="2.7952943"
		stroke="currentColor"
		stroke-width="1"
		stroke-linecap="round"
		stroke-linejoin="round"
		id="rect4-4"
		style="fill:currentColor;fill-opacity:0"
	/>
</svg>
